<template>
  <div class="contact">
    <div class="title">
      CONTACT
    </div>
    <div class="contact-us">
      <router-link to="contact">
      <div class="button">
      お問い合わせ
      </div>
    </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contact',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .contact{
    background-color: #E4E4E4;
    padding-top: 6.8vw;
    padding-bottom: 6.8vw;
    position: relative;
    z-index: 1;

    a, a:visited{
      text-decoration: none;
    }
  }
  .title{
    color: #3B3B3B;
    font-size: 2.4vw;
    font-weight: bold;

    @media (max-width: 550px) {
      font-size: 30px;
      padding: 10px;
      padding-top: 20px;
    }
  }
  .contact-us{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3.6vw;

    .button{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 22vw;
      height: 5.5vw;
      background-color: #3B3B3B;
      color: #FFF;
      font-size: 1vw;
      font-weight: bold;

      @media (max-width: 550px) {
        font-size: 14px;
        width: 308px;
        height: 77px;
      }
      transition: background-color .4s ease;
      -webkit-transition: background-color .4s ease;
      cursor: pointer;
    }
    .button:hover{
      color: #fff;
      background-color: #D0AF1F;
    }

    @media (max-width: 550px) {
      padding: 30px;
      padding-bottom: 60px;
    }

  }
</style>
